var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalProtections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 58,
    viewBox: "0 0 73 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 44.653c-2.318.557-4.878.86-7.696.86h-.608c-18.435 0-25.826-12.98-26.609-25.117a20.683 20.683 0 01-.087-1.64c.022-.27.033-.542.044-.82.01-.265.022-.536.043-.818.391-6.072 2.437-12.355 6.691-17.118H68a5 5 0 015 5v39.653z",
    fill: "#FE98B7",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dLegalContracts)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.54 36.539c-.013 1.755-4.784 3.699-10.305 3.699-5.52 0-10.128-1.939-10.202-3.699-.257-6.105 4.68-2.668 10.202-2.668s10.355-4.36 10.305 2.668z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.233 34.305c0 1.757-4.477 3.699-9.998 3.699-5.52 0-9.997-1.937-9.997-3.699 0-1.762 4.475-2.666 9.998-2.666 5.522 0 9.997.91 9.997 2.666z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.283 33.612c-.01 1.37-3.73 2.88-8.038 2.88-4.307 0-7.898-1.513-7.958-2.88-.2-4.761 3.651-2.081 7.959-2.081 4.307 0 8.078-3.4 8.037 2.081z",
    fill: "#FE98B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.044 30.759c0 1.531-3.49 3.22-7.798 3.22-4.307 0-7.799-1.682-7.799-3.22 0-1.539 3.492-2.324 7.8-2.324 4.306 0 7.797.79 7.797 2.324zM55.558 4.004s1.475 1.627 1.729 3.456c.254 1.83-7.21 4.639-7.21 4.639s-2.587-1.513-2.675-2.93c0 0 4.954-5.327 8.156-5.165z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.392 8.02l4.245 7.08-4.317 3.668-3.366.63-1.05-1.894-2.955-5.484 7.443-4z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.695 14.402s2.867 3.048 2.13 4.696c-.735 1.647-4.622 4.95-7.098 4.446-2.475-.502-2.871-4.154-2.871-4.154l7.839-4.988zM29.084 27.363L51.043 14s2.087.27 1.86 3.067L31.154 30.574a2.25 2.25 0 01-1.483.32c-.595-.081-1.3-.298-1.528-.865a1.912 1.912 0 01-.121-.449 2.218 2.218 0 011.062-2.217z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.39 7.023a.54.54 0 01.492.407c.108.378-.09.741-.296 1.044a5.608 5.608 0 01-1.361 1.392c-.894.648-1.761 1.377-2.773 1.85a8.48 8.48 0 01-1.828.576 6.211 6.211 0 01-1.439.158.423.423 0 01-.26-.748c.224-.148.473-.253.736-.31 1.309-.384 2.52-1.052 3.655-1.81a11.478 11.478 0 001.709-1.345c.35-.346.797-1.227 1.364-1.214zm3.503 6.838s2.154-.052.371 2.115c-1.783 2.167-4.972 4.318-7.243 3.832 0 0-.94-.78-.127-.915.771-.128 4.369-.84 6.023-2.846a4.24 4.24 0 01.603-.595c.388-.316.91-.915.373-1.59z",
    fill: "#FE98B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.407 18.637c.46.769-1.022 2.507-3.312 3.882s-4.52 1.867-4.982 1.097c-.462-.769 1.021-2.507 3.311-3.882s4.521-1.867 4.983-1.097z",
    fill: "#F5F4F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dLegalContracts",
    x: 27,
    y: 4,
    width: 42.54,
    height: 38.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalProtections);
export default __webpack_public_path__ + "static/media/legal-protections.2e4585621d17113f2edb322e2536933d.svg";
export { ForwardRef as ReactComponent };